import React, { useEffect, useState } from "react";
import { createMaterialTopTabNavigator } from '@react-navigation/material-top-tabs';

import MosaicOfPublications from "../components/MosaicOfPublications";

import MosaicOfSeedsScreen from "../screens/MosaicOfSeedsScreen";
import MosaicFixoSeeds from "../screens/MosaicFixoSeeds";

const Tab = createMaterialTopTabNavigator();


const SlideNavigator = (props) => {

  return (
    <Tab.Navigator >
      <Tab.Screen
        name="Semillas"
        children={() => <MosaicOfSeedsScreen
          userId={props.userId}
          navigation={props.navigation}
          foundUserChecker={props.foundUserChecker}
        />
        }
      />
      <Tab.Screen
        name="Publicaciones"
        children={() => <MosaicOfPublications userId={props.userId}
          navigation={props.navigation}
          foundUserChecker={'off'}
        />}

      />
      <Tab.Screen
        name="Fixo"
        children={() => <MosaicFixoSeeds
          userId={props.userId}
          navigation={props.navigation}
          foundUserChecker={props.foundUserChecker}
        />
        }
      />
    </Tab.Navigator>
  );
};

export default SlideNavigator;
